import React from 'react';
import update from 'immutability-helper';

import {browserHistory} from 'react-router';
import {modal} from '../../core/utilities/modal';
import {signupHelper} from '../../helpers/Signup';

export default class ForgotPasswordCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userData: {
                password: '',
                confirmPassword: ''
            },
            email: '',
            userConfirmed: false,
            setPassword: false
        };
    }

    componentDidMount() {
        var self = this;
        if (this.props.params.token) {
            signupHelper.confirmUser(this.props.params.token, function(data) {
                if(data.status != 409) {
                    self.setState({
                        userConfirmed: true,
                        setPassword: true,
                        email: data.data.username
                    });
                }
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
    }

    signUp(e){
        e.preventDefault();
        var self = this;
        const email = this.state.email;

        if(email == "") {
            modal.showInfo("Enter an email address.", "warning", "top", "center");
            return;
        }
        if(!this.emailIsValid(email)) {
            modal.showInfo("You've entered an invalid email.", "warning", "top", "center");
            return;
        }

        signupHelper.forgotPassword(email, function(data) {
            modal.showInfo("If this account exist, an email has been sent.", "success", "top", "center");
            self.setState({
                email: ''
            });
        });
    }

    createPassword(e) {
        e.preventDefault();

        var self = this;
        const password = this.state.userData.password;
        const confirmPassword = this.state.userData.confirmPassword;
        if(password == "" || confirmPassword == "") {
            modal.showInfo("Enter a password.", "warning", "top", "center");
            return;
        }

        if(password != confirmPassword) {
            modal.showInfo("Passwords do not match.", "warning", "top", "center");
            return;
        }

        const data = {
            password: password,
            confirmPassword: confirmPassword,
            email: this.state.email
        }

        signupHelper.resetPassword(data, function(data) {
            if (data.status != 409) {
                modal.showInfo("Password has been updated.", "success", "top", "center");
                browserHistory.replace('/login');
            }
        });
    }

    passwordChange(e){
        this.setState({
            userData: update(this.state.userData, {
                password: {$set: e.target.value
                }}
            )
        });
    }

    confirmpasswordChange(e){
        this.setState({
            userData: update(this.state.userData, {
                confirmPassword: {$set: e.target.value
                }}
            )
        });
    }

    login(e) {
        e.preventDefault();
        browserHistory.replace('/login');
    }

    emailIsValid(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }

    emailChange(e){
        this.setState({
            email: e.target.value
        });
    }

    render(){
        const setPassword = this.state.setPassword;
        const userData = this.state.userData;
        return (
            <div class="new-login-card">
                <div className="">
                    <h4 className="title login-right-panel-text">Forgot Password?</h4>
                    {setPassword ? (
                        <p className="category">Enter a new password to associate with your account</p>
                    ) : (
                        <p className="category">Enter your email and a password reset link will be set to you</p>
                    )}
                </div>
                <div className="login-box-body">
                    <p className="login-box-msg"><span></span></p>
                    <form action="" method="post" onsubmit="return false;">
                        <div>
                            {setPassword ? (
                                <div>
                                    <div class="form-group has-feedback">
                                        <input type="password" class="form-control" id="password" value={userData.password} onChange={this.passwordChange.bind(this)} placeholder="Password" style={{
                                            backgroundColor: 'white',
                                            paddingLeft: "50px"
                                        }}/>
                                        <i class="form-control-feedback fa fa-lock"></i>
                                    </div>
                                    <div class="form-group has-feedback">
                                        <input type="password" class="form-control" id="repassword" value={userData.confirmPassword} onChange={this.confirmpasswordChange.bind(this)} placeholder="Re-Enter Password" style={{
                                            backgroundColor: 'white',
                                            paddingLeft: "50px"
                                        }}/>
                                        <i class="form-control-feedback fa fa-lock"></i>
                                    </div>
                                </div>
                            ) : (
                                <div className="form-group has-feedback">
                                    <input type="text" name="log" className="form-control" id="email" value={this.state.email} onChange={this.emailChange.bind(this)} placeholder="Email" style={{
                                        backgroundColor: "white",
                                        paddingLeft: "50px"
                                    }}/>
                                    <i className="form-control-feedback fa fa-envelope"></i>
                                </div>
                            )}
                            <div className="row login-inputs">
                                <div>
                                    <div className="loading"><i className="fa fa-cog fa-spin"></i></div>
                                    {setPassword ? (
                                        <button type="submit" onClick={this.createPassword.bind(this)} name="submit" id="login" className="col-md-6 col-md-3 btn btn-secondary btn-info btn-fill btn-block btn-flat login">
                                            Create Password
                                        </button>
                                    ) : (
                                        <div>
                                            <button type="submit" onClick={this.signUp.bind(this)} name="submit" id="login" className="btn btn-secondary btn-info btn-fill btn-block btn-flat login">
                                                <img height="1" width="1" style={{display: 'none'}} alt="" src="https://px.ads.linkedin.com/collect/?pid=2004218&conversionId=2171594&fmt=gif"/>
                                                Send Link
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="row text-center no-margin" style={{padding: "20px", paddingBottom: "0px"}}>
                                <p>
                                    Already have an account?{" "}
                                    <a onClick={this.login} className="register"> Login </a>
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Login/ForgotPasswordCard.jsx